import { MouseEventHandler } from 'react';

export interface IconWithTooltipModel {
  text: string;
  mainClass?: string;
  iconColor?: string;
  bgColor?: string;
}

const handleClick: MouseEventHandler = (e) => {
  const bodyStyle = document.body.style;
  const desktopBreakpoint = bodyStyle.getPropertyValue('--breakpoint-desktop');
  if (desktopBreakpoint.length === 0) return;
  if (parseInt(desktopBreakpoint) > window.innerWidth) {
    e.stopPropagation();
  }
};

const IconWithTooltip = (props: IconWithTooltipModel) => {
  return (
    <div
      className={`fm-o-icon-w-tooltip ${props.bgColor ? `fm-o-icon-w-tooltip--${props.bgColor}` : ''} ${props.mainClass ?? ''}`}
      onClick={handleClick}
    >
      <details>
        <summary>
          <div className="fm-o-icon-w-tooltip__flex-container">
            <div className="fm-o-icon-w-tooltip__icon-text">
              <svg width="2" height="13" viewBox="0 0 2 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.513031 3.96373H1.64703V12.9997H0.513031V3.96373ZM1.08903 0.219727C1.32903 0.219727 1.53303 0.309726 1.70103 0.489726C1.88103 0.657726 1.97103 0.861727 1.97103 1.10173C1.97103 1.34173 1.88103 1.54573 1.70103 1.71373C1.53303 1.88173 1.32903 1.96573 1.08903 1.96573C0.837031 1.96573 0.627031 1.88173 0.459031 1.71373C0.291031 1.54573 0.207031 1.34173 0.207031 1.10173C0.207031 0.861727 0.291031 0.657726 0.459031 0.489726C0.627031 0.309726 0.837031 0.219727 1.08903 0.219727Z"
                  fill={props?.iconColor || '#1B1D2B'}
                />
              </svg>
            </div>
            <div className="fm-o-icon-w-tooltip__icon-text--open">
              <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.77076 1.23914L1.24902 7.76087M1.24902 1.23914L7.77076 7.76087L1.24902 1.23914Z"
                  stroke="white"
                  stroke-width="1.30435"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div className="fm-o-icon-w-tooltip__content">
              <div className="fm-o-icon-w-tooltip__content-wrapper">{props.text}</div>
            </div>
          </div>
        </summary>
      </details>
    </div>
  );
};

export default IconWithTooltip;
